// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1i_n-","containerItemsCenter":"Skeleton_containerItemsCenter__1Orgi"};